import IconFont from '@/common/IconFont';
import { Divider, Dropdown, Menu } from 'antd';
import { useDispatch, useRouter, useUserInfo } from '@/hooks/hooks';
import style from '../style/FrontLayout.module.less';
import { logout as logoutAction, changeSchool as changeSchoolAction } from '@/store/slices/user';

interface FrontHeaderProps {
  bottom?: boolean;
  hideUserInfo?: boolean;
}
const FrontHeader: React.FC<FrontHeaderProps> = props => {
  const userState = useUserInfo();
  const dispatch = useDispatch();
  const router = useRouter();
  const logout = () => {
    dispatch(logoutAction());
  };

  // 点击切换学校
  const changeSchool = (schoolId: number) => {
    dispatch(changeSchoolAction(schoolId));
    router.to('/');
  };

  return (
    <div className={`${style.header} ${props.bottom ? style.bottom : ''}`}>
      <div>
        <img src={require('@/assets/imgs/logo-black.svg').default} alt="" />
        {
          !props.hideUserInfo && (
            <div className={style.userInfo}>
              <div className={style.userInfo}>
                <img src={require('@/assets/imgs/user-head.png')} alt="" />
                <span>{userState.name}</span>
              </div>
              {/* 学校名称 */}
              {
                userState.userType === 'TEACHER' && (
                  <>
                    <Divider type="vertical"></Divider>
                    {
                      userState.schools.length <= 1 ? <span>{userState.currentSchool.name}</span> : (
                        <Dropdown
                          placement="bottom"
                          overlay={<Menu
                            items={userState.schools.map(i => ({
                              key: i.id,
                              label: <span>{i.name}</span>,
                              onClick: () => changeSchool(i.id)
                            }))}
                          />}
                          trigger={['click']}
                        >
                          <div className={style.schoolName}>
                            <span>{userState.currentSchool.name}</span>
                            <IconFont type="icon-zhankai" />
                          </div>
                        </Dropdown>
                      )
                    }
                  </>
                )
              }
              <Divider type="vertical"></Divider>
              <div onClick={logout}>
                <span>退出</span>
                <IconFont style={{marginTop: '2px'}} type="icon-tuichu1" />
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default FrontHeader;
